/**
 * Single source of truth for breakpoints.
 * SCSS mirrors these values in _breakpoints.scss.
 *
 * Three tiers:
 *   small   — < 600px   (mobile)
 *   medium  — 600–899px  (tablet)
 *   large   — >= 900px   (desktop)
 */

export const BREAKPOINTS = {
  sm: 600,
  lg: 900,
};

export const SCREEN_TIERS = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};

export const getScreenTier = (width) => {
  if (width < BREAKPOINTS.sm) return SCREEN_TIERS.SMALL;
  if (width < BREAKPOINTS.lg) return SCREEN_TIERS.MEDIUM;
  return SCREEN_TIERS.LARGE;
};
